
import { HeaderNavigationTopicComponent } from '@/packages/Header/src/HeaderNavigationTopic';
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import headerMixin from '@owc-utils/Mixins/Header';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';
import { FlyoutLevels } from '@owc-packages/Header/src/Header.enums';

import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
import HeaderFlyout from '@owc-packages/Header/src/HeaderFlyout.vue';
import OwcHeaderButton from '@owc-packages/Header/src/HeaderButton.vue';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import { AEM_AUTHOR_CLASS, HEADER_MAIN_NAV_FLYOUT } from '@owc-packages/Header/src/Header.configs';
import { buildHeaderComponentId } from './HeaderUtils';
import { updateActiveFlyout } from '@owc-utils/Seamless/headerIntegrations';
import { HeaderState } from '@owc-types/Header';

export default (ComponentInitializeDispatcher as HeaderNavigationTopicComponent).extend({
  name: 'owc-header-navigation-topic',
  mixins: [headerMixin, OwcDataComponent],
  components: {
    SlotContainer,
    HeaderFlyout,
    OwcHeaderButton,
    ValidationBoxWrapper,
  },
  mounted() {
    this.innerComponentId = this.getComponentId();

    if (!this.innerComponentId) {
      this.innerComponentId = buildHeaderComponentId(
        'topic',
        this.navigationTopicLabel.trim(),
        this.componentData?.listIndex,
      );
    }

    this.storeStateChangeListener = this.onHeaderStateChange(state => {
      if (this.isEditMode) {
        this.$el.classList.add(AEM_AUTHOR_CLASS);
      } else {
        this.openFlyoutIfPartOfChain(state);
      }
    });

    this.openFlyoutIfPartOfChain();
  },
  beforeDestroy() {
    if (this.storeStateChangeListener) {
      this.removeOnHeaderStateChange(this.storeStateChangeListener);
    }
  },
  data() {
    return {
      shouldShowInnerFlyout: false,
      isFlyoutNavVisible: true,
      innerComponentId: '',
    };
  },
  computed: {
    navigationTopicLabel() {
      if (this.componentData) {
        return this.componentData.label;
      }
      return '';
    },
    analyticsId() {
      if (this.componentData) {
        return this.componentData.analyticsId || this.componentData.label;
      }
      return '';
    },
    currentFlyoutLevel() {
      if (this.componentData?.currentFlyoutLevel) {
        return this.componentData?.currentFlyoutLevel;
      }

      return FlyoutLevels.FLYOUT_LEVEL_ONE;
    },
    nextFlyoutLevel() {
      if (this.currentFlyoutLevel) {
        return this.currentFlyoutLevel + 1;
      }

      return FlyoutLevels.FLYOUT_LEVEL_TWO;
    },
    innerFlyoutItems() {
      if (this.componentData && this.componentData.items) {
        return [...this.componentData.items];
      }

      return [];
    },
    isTopicPartOfDesktopNavigation() {
      return Boolean(this.componentData?.isTopicPartOfDesktopNavigation);
    },
    //TODO: This logic might no longer be necessary if this component will no longer be a WC
    isModelsFlyout() {
      const componentId = this.getComponentId();

      if (componentId) {
        return [this.getModelTopicId()].includes(this.getComponentId());
      } else {
        return this.componentData?.listIndex === 0 && this.isTopicPartOfDesktopNavigation;
      }
    },
    iconName() {
      const businessUnit = window?.aemNamespace?.pageEnvironmentVariables?.businessUnit;
      if (businessUnit === 'vans' || businessUnit === 'camper-vans') {
        return 'bds/van-frontal/24';
      } else return 'bds/car/24';
    },
  },
  methods: {
    openFlyout() {
      if (this.shouldShowInnerFlyout) {
        this.closeFlyout(this.isTopicPartOfDesktopNavigation);
      } else {
        const openFlyoutChain = [];

        updateActiveFlyout(this.$refs.flyout, HEADER_MAIN_NAV_FLYOUT, true);
        this.setOpenFlyoutId(this.innerComponentId);

        if (this.isTopicPartOfDesktopNavigation) {
          openFlyoutChain.push({
            infoToAdd: HEADER_MAIN_NAV_FLYOUT,
            flyoutLevel: FlyoutLevels.FLYOUT_LEVEL_ONE,
          });
        }
        openFlyoutChain.push({ infoToAdd: this.innerComponentId, flyoutLevel: this.nextFlyoutLevel });

        this.openHeaderFlyout(openFlyoutChain);
        this.addToTrackingTree(this.analyticsId, this.nextFlyoutLevel);
      }
    },
    closeFlyout(isGlobalClose: boolean) {
      updateActiveFlyout(this.$refs.flyout, HEADER_MAIN_NAV_FLYOUT, false);

      this.closeHeaderFlyout(isGlobalClose, true);
    },
    openFlyoutIfPartOfChain(storeState: HeaderState) {
      const state = storeState || this.getHeaderStoreState();
      const isModelsFlyoutOpen = state.modelsFlyoutOpen;

      this.shouldShowInnerFlyout = this.isThisFlyoutOpen(state.flyoutChain, this.innerComponentId);
      this.isFlyoutNavVisible = !(this.isModelsFlyout && isModelsFlyoutOpen);

      if (!this.shouldShowInnerFlyout) {
        this.$el.classList.remove('owc-header-navigation-topic--selected');
      } else {
        this.$el.classList.add('owc-header-navigation-topic--selected');
      }
    },
  },
});
